import clsx from 'clsx';
import { CSSProperties, ReactNode } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';

import style from './SplitScreen.module.css';

export interface SplitScreenProps {
  id: string;
  left: ReactNode;
  right: ReactNode;
  splitRatio?: number;
  animationDisabled?: boolean;
}

// TODO: DISABLE ANIMATION WHEN SPIT RATIO CHANGES
export const SplitScreen = ({ left, right, id, splitRatio, animationDisabled }: SplitScreenProps) => {
  return (
    <div className={clsx(style.root)} style={splitRatio != null ? ({ '--splitRatio': `${splitRatio * 100}%` } as CSSProperties) : undefined}>
      <div className={clsx(style.left)}>
        <SwitchTransition mode="in-out">
          <CSSTransition key={id} timeout={!animationDisabled ? 300 : 0} classNames="fade-overlay">
            {left}
          </CSSTransition>
        </SwitchTransition>
      </div>

      <div className={clsx(style.right)}>
        <SwitchTransition mode="out-in">
          <CSSTransition key={`${id}.right`} timeout={!animationDisabled ? 250 : 0} classNames="fade">
            {right}
          </CSSTransition>
        </SwitchTransition>
      </div>
    </div>
  );
};
